import { usePageTitle } from "hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import { ConfirmBox } from "views/lms/enrollment/Home/Confirm/ConfirmBox";
import { OperationBox } from "views/lms/enrollment/Home/Operation/OperationBox";
import { ResultBox } from "views/lms/enrollment/Home/Result/ResultBox";
import { StepManagement } from "views/lms/enrollment/Home/StepManagement";
import { ListTrainings } from "views/lms/enrollment/Home/Training/ListTrainings";

/**
 * Gerencimento de Inscrições.
 */
export const EnrollmentManager: React.FC = () => {
    const { t } = useTranslation("lms");

    usePageTitle(t("Enrollment.Common.Title"));

    return <StepManagement
        steps={
            [
                { name: t("Enrollment.StepTraining.TabName"), enabled: false, visible: true, render: ListTrainings },
                { name: t("Enrollment.StepOperation.TabName"), enabled: false, visible: true, render: OperationBox },
                { name: t("Enrollment.StepConfirm.TabName"), enabled: false, visible: true, render: ConfirmBox },
                { name: t("Enrollment.StepResult.TabName"), enabled: false, visible: true, render: ResultBox }
            ]
        }
    />;
};
